import {cloneDeep, find, set} from 'lodash';

const actions = {
    DASHBOARD_PANELS_INIT: (state, {dashboard}) => {
        const {columnSizes, panels} = dashboard;

        return {...state, columnSizes, panels};
    },

    DASHBOARD_PANEL_EXPAND_COLLAPSE: (state, {panel, collapse}) => {
        const newState = cloneDeep(state);

        set(find(newState.panels, ['name', panel]), 'panelCollapsed', collapse);
        return newState;
    },

    DASHBOARD_HIDE_PANEL: (state, {panel, hide}) => {
        const newState = cloneDeep(state);

        set(find(newState.panels, ['name', panel]), 'hide', hide);
        return newState;
    },
};

const reducer = (state = {panels: []}, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
